<template>
<section>
    

    <div class="wrap">
        <div class="consultant_name_box">
            
            <div class="consultant_name_pic">
                <img :src="viewScAttUrl((scItem.att) ? scItem.att.url : null)">
            </div>

            <dl class="consultant_name">
                <dt>{{scItem.name}} <span>/ 컨설턴트 / 경력 7년차</span></dt>
                <dd>
                    <span>{{ (scItem.shop) ? scItem.shop.name : '' }}전시장</span>
                    <span>{{ (scItem.dealer) ? scItem.dealer.name : '' }}</span>
                </dd>
            </dl>

        </div>
        <div class="find_consultant_info">
        
            <ReviewList
                filterChk
                v-model="score"
                :items="reviewItems" 
                :totalCount="totalCount"
            />
        </div>
    </div>

</section>


</template>

<script>
import { mapGetters,mapState } from 'vuex';
import ReviewList from '../../components/review/ReviewList.vue';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'ScReviewList',
    mixins: [ InfinityScrollMixin ],
    components: { 
        ReviewList ,
    },

    data() {
        return {
            score: '',
        }
    },
    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            scItem: state => state.sc.item
        }),
        ...mapGetters([
            'viewScAttUrl'
        ]),
        scId() {
            return this.$route.params.scId;
        }
    },
    watch: {
        score() {
            this.$store.commit('CLEAR_REVIEW_LIST');
            this.changeSearchOption();
        }
    },
    created() {
        this.$store.dispatch('GET_SC', this.scId)
        .then(() => {
            this.setScroll();
            this.getContentList();
            this.$store.commit('SHOW_ONLOAD');
        });
    },
    destroyed() {
        this.removeScroll();
    },
    methods: {
        getContentList() {

            if(this.reviewItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_REVIEW_LIST_PAGE',
                    {
                        scId: this.scId,
                        hasContent: 1,
                        score: this.score,
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>

<style>
    .customer_reviews{
        padding-bottom:30px
    }
</style>